/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import {
    Card,
    CardContent,
    FormControl,
    Link,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
    Button as MaterialButton,
} from "@mui/material";
import {
    GridActionsCellItem,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
} from "@mui/x-data-grid";
import AddchartIcon from "@mui/icons-material/Addchart";
import BarChartIcon from "@mui/icons-material/BarChart";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState, useRef, useCallback, ChangeEvent } from "react";
import { useForm } from "react-hook-form";

import {
    RequestFilterValueTypeEnums,
    mapReactFilterValueTypeToRequestFilterValueType,
    mapReactMUIToFilterOperationTypes,
} from "../../../common/enums/RequestFilterEnums";
import {
    PagingResponse,
    useAuthorization,
    useGetEneryaReconciliationList,
    useImportEneryaReconciliation,
} from "../../../hooks";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { useUserInfoValue } from "../../../store/User.state";
import { downloadExcel } from "../../../util/downloadExcel";
import {
    Button,
    Loading,
} from "../../atoms";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { DeleteConfirmModal } from "../../molecules";
import {
    DatePickerControl,
    DateTimePickerControl,
    InputControl,
} from "../../molecules/form-fields";
import { Table } from "../../molecules/table";

import {
    EneryaListingPageInitialValues,
    EneryaListingPageValuesType,
} from "./_formTypes";

interface Filter {
    field: string;
    values: string[];
    operationType: number;
    valueType: number;
}

const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
};

const getQueryParams = (filters: any) => {
    const queryParams: any = {};
    for (const key in filters) {
        const value = filters[key];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            queryParams[key] = value;
        }
    }
    return queryParams;
};

const convertTableFiltersToRequestFilter = (tableFilters: any, columns: GridColDef[]) => {
    const convertedFilters: any[] = [];
    if (tableFilters?.items) {
        tableFilters.items.forEach((item: any) => {
            const findColumn = columns.find((x) => x.field === item.field);
            if (findColumn && (findColumn as any).columnType) {
                convertedFilters.push({
                    field: item.field,
                    values: [item.value.toString()],
                    valueType: mapReactFilterValueTypeToRequestFilterValueType(
                        item.value,
                        (findColumn as any).columnType
                    ),
                    operationType: mapReactMUIToFilterOperationTypes(item.operator),
                });
            }
        });
    }
    return convertedFilters;
};


const formatCurrency = (amount: number) => {
    if (typeof amount !== 'number') return '';
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
};

export const EneryaListingPage = () => {
    const userInfo = useUserInfoValue();
    const [tableData, setTableData] = useState<PagingResponse<any> | undefined>();
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });
    const [queryOptions, setQueryOptions] = useState({});
    const {
        control,
        handleSubmit,
        setValue,
    } = useForm<EneryaListingPageValuesType>({
        defaultValues: EneryaListingPageInitialValues,
    });
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const { showUpdate, showDelete } = useAuthorization();
    const [tableselectedRow, setTableSelectedRow] = useState<any | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const {
        mutate: getEneryaList,
        isLoading: isGetEneryaListLoading,
    } = useGetEneryaReconciliationList();

    const isDeleteEntityLoading = false;

    const {
        mutate: importFile,
        isLoading: isImportingFile,
    } = useImportEneryaReconciliation();


    const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
    const [showTable, setShowTable] = useState(false)
    const setSnackbar = useSetSnackBar();

    useEffect(() => {
        setValue("startDate", dayjs().startOf("month"));
        setValue("endDate", dayjs());
    }, [setValue]);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    useEffect(() => {
        const savedFilter = localStorage.getItem("EneryaListingPageFilter");
        if (savedFilter) {
            setQueryOptions(JSON.parse(savedFilter));
        }
    }, []);

    const [formValues, setFormValues] = useState<any | null>(null);
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [dynamicFilters, setDynamicFilter] = useState<any[]>([]);

    const refreshData = useCallback(() => {
        const requestPayload = {
            ...formValues,
            ...getQueryParams(queryOptions),
            size: paginationModel.pageSize,
            page: paginationModel.page,
        };

        if (requestPayload.filters) {
            requestPayload.filters = [
                ...requestPayload.filters,
                ...dynamicFilters
            ]
        }

        getEneryaList(requestPayload, {
            onSuccess: (data: any) => {
                if (data.isSuccess) {
                    setTableData(data.data);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setTableData(undefined);
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: (error: any) => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    }, [formValues, queryOptions, paginationModel, dynamicFilters, getEneryaList, setSnackbar]);

    const onSubmit = (data: EneryaListingPageValuesType) => {
        setPaginationModel({
            page: 0,
            pageSize: paginationModel.pageSize
        });
        setFilterAccordionExpand(false);
        setTableData(undefined);
        setShowTable(true);

        const req: {
            startDate: string;
            endDate: string;
            size: number;
            page: number;
            orderBy: string;
            merchantId: number;
            filters: Filter[];
        } = {
            startDate: data?.startDate
                ? dayjs(data.startDate).format("YYYY-MM-DD")
                : "",
            endDate: data?.endDate
                ? dayjs(data.endDate).format("YYYY-MM-DD")
                : "",
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "Id",
            orderByDesc: true,
            merchantId: +userInfo.merchantId,
            filters: [] as Filter[],
        };

        setFormValues(req);
        setIsSubmitted(true);
    };

    useEffect(() => {
        if (!isSubmitted || !formValues) {
            return;
        }
        refreshData();
    }, [formValues, isSubmitted, refreshData]);

    const handleFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    };

    const handleUpload = () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append("file", selectedFile);

            importFile(formData, {
                onSuccess: (data) => {
                    if (data.isSuccess) {
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: data.message,
                        });
                        setSelectedFile(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        refreshData();
                    } else {
                        setSnackbar({
                            severity: "error",
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: (error: any) => {
                    setSnackbar({
                        severity: "error",
                        description: error?.response?.data?.message || "Dosya yüklenirken bir hata oluştu.",
                        isOpen: true,
                    });
                },
            });
        }
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const deleteRow = useCallback(
        (row: any) => () => {
            setTableSelectedRow(row);
            setIsDeleteModalOpen(true);
        },
        []
    );

    const handleDeleteConfirm = () => {
        console.log("Deleting row:", tableselectedRow);
        handleCloseDeleteModal();
        setSnackbar({
            severity: "info",
            isOpen: true,
            description: "Silme işlemi entegre edilecek.",
        });
        // TODO: Implement your delete logic
    };

    const columns: GridColDef[] = useMemo(() => {
        return [
            { field: "fileName", headerName: "Dosya Adı", width: 220, columnType: RequestFilterValueTypeEnums.STRING },
            {
                field: "date", headerName: "Tarih", width: 150, columnType: RequestFilterValueTypeEnums.DATE,
                renderCell: (params) => dayjs(params.value).format("DD.MM.YYYY"),
                filterable: false
            },
            { field: "companyCode", headerName: "Şirket Kodu", width: 150, columnType: RequestFilterValueTypeEnums.STRING },
            {
                field: "eneryaTotalAmount",
                headerName: "Enerya Toplam Tutar",
                width: 200,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                renderCell: (params) => formatCurrency(params.value)
            },
            {
                field: "systemTotalAmount",
                headerName: "Sistem Toplam Tutar",
                width: 200,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                renderCell: (params) => formatCurrency(params.value),
                filterable: false
            },
            {
                field: "totalAmountDifferences",
                headerName: "Toplam Tutar Farkı",
                width: 200,
                columnType: RequestFilterValueTypeEnums.NUMBER,
                renderCell: (params) => formatCurrency(params.value),
                filterable: false
            },
            { field: "channelInformation", headerName: "Kanal Bilgisi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
        ];
    }, [deleteRow, showDelete, showUpdate]);

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
        setTableData(undefined);
    };

    const onSave = () => {
        const requestPayload = {
            ...formValues,
            ...getQueryParams(queryOptions),
            size: tableData?.totalItems > 0 ? tableData?.totalItems : 999, // to fetch all
            page: 0,
        };

        if (requestPayload.filters) {
            requestPayload.filters = [
                ...requestPayload.filters,
                ...dynamicFilters
            ]
        }

        getEneryaList(requestPayload, {
            onSuccess: (data: any) => {
                if (data.isSuccess) {
                    function fieldValue(data) {
                        return data?.map((item) => {
                            return {
                                "Dosya Adı": item?.fileName,
                                "Tarih": dayjs(item.date).format("DD.MM.YYYY"),
                                "Şirket Kodu": item?.companyCode,
                                "Enerya Toplam Tutar": item?.eneryaTotalAmount,
                                "Sistem Toplam Tutar": item?.systemTotalAmount,
                                "Toplam Tutar Farkı": item?.totalAmountDifferences,
                                "Kanal Bilgisi": item?.channelInformation,
                            };
                        });
                    }
                    const refactoredData = fieldValue(data?.data?.result);
                    downloadExcel(refactoredData || [], "Enerya Mutabakat Listesi");
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: (error: any) => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    };

    const previousQueryParams = useRef({});
    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            localStorage.removeItem('EneryaListingPageFilter')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        const allValuesValid = Object.values(queryParams).every((value: any) => value.toString().length >= 3);

        if (allValuesValid || currentKeysLength < previousKeysLength) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters, columns));
            localStorage.setItem('EneryaListingPageFilter', JSON.stringify(queryParams));
        }

        previousQueryParams.current = queryParams;

    }, 500);

    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    const hasLoading = isGetEneryaListLoading || isImportingFile;

    return (
        <>
            {hasLoading && <Loading />}
            <Stack flex={1} justifyContent="space-between">
                <Stack flex={1} p={2}>
                    <Card sx={{ mb: 2 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Enerya Mutabakat Dosyası Yükleme
                            </Typography>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <MaterialButton
                                    variant="outlined"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    Dosya Seç
                                </MaterialButton>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    hidden
                                    accept=".xlsx, .xls"
                                    onChange={handleFileSelect}
                                />
                                {selectedFile && <Typography>{selectedFile.name}</Typography>}
                                <MaterialButton
                                    variant="contained"
                                    onClick={handleUpload}
                                    disabled={!selectedFile}
                                >
                                    Yükle ve İşleme Başla
                                </MaterialButton>
                            </Stack>
                        </CardContent>
                    </Card>
                    <BaseFilterTableWithAccordion
                        summary="Filtre"
                        isExpanded={isFilterAccordionExpanded}
                        setExpanded={setFilterAccordionExpand}
                        setTableVisibility={setShowTable}
                        child={
                            <Stack spacing={4}>
                                <Stack
                                    spacing={3}
                                    direction={isDesktop ? "row" : "column"}
                                    width={isDesktop ? "100%" : "auto"}
                                    maxWidth={1308}
                                >
                                    <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                        <DatePickerControl
                                            sx={{ flex: 1 }}
                                            id="startDate"
                                            control={control}
                                            label="Başlangıç Tarihi"
                                            defaultValue={dayjs().startOf("month")}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                        <DatePickerControl
                                            sx={{ flex: 1 }}
                                            id="endDate"
                                            control={control}
                                            label="Bitiş Tarihi"
                                            defaultValue={dayjs()}
                                        />
                                    </FormControl>
                                    <div style={{ flex: 1 }} />
                                </Stack>

                                <Stack
                                    direction="row"
                                    justifyContent="flex-end"
                                    width={isDesktop ? "100%" : "auto"}
                                    maxWidth={1308}
                                >
                                    <Button
                                        onClick={handleSubmit(onSubmit)}
                                        variant="contained"
                                        text={"ARA"}
                                    />
                                </Stack>
                            </Stack>
                        }
                    />
                    <Stack flex={1} mt={2}>
                        {showTable && (
                            <>
                                <Table
                                    columnVisibilityConfigKey="EneryaListingPageFilterVisibilityKey"
                                    filterKey="EneryaListingPageFilter"
                                    hasActiveFilters={hasActiveFilters}
                                    handleFilterChange={handleFilterChange}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={handleChangePagination}
                                    paginationMode="server"
                                    rowCount={tableData?.totalItems || 0}
                                    isRowSelectable={() => false}
                                    rows={tableData?.result || []}
                                    customLabelDisplayedRows={true}
                                    autoHeight={false}
                                    columns={columns}
                                    exportFileName="Liste"
                                    onSave={onSave}
                                />
                            </>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
};